import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { ArcRotateCamera } from "@babylonjs/core/Cameras/arcRotateCamera";
import { Scene } from "@babylonjs/core/scene";
import { gsap } from "gsap";
import { TrackingShot } from "../classes/TrackingShot";



/**
 * Verwaltet die Main-Camera der Szene
*/
export abstract class CameraHelper {

  private static _mainCamera: ArcRotateCamera;
  public static get mainCamera() { return this._mainCamera }
  private static set mainCamera(camera: ArcRotateCamera) { this._mainCamera = camera; }

  public static trackingShots: TrackingShot[] = [
    new TrackingShot(1.75, 1.49, 5, new Vector3(0, .75, 0)),
    new TrackingShot(2.75, 1.49, 5, new Vector3(0, .75, 0)),
    new TrackingShot(0.75, 1.49, 5, new Vector3(0, .75, 0)),
  ]
  private static isTrackingShotRunning: boolean = false;

  /**
  * Erstellt eine Kamera mit angegebenen Parametern und setzt sie als MainCamera
  */
  public static CreateMainCamera = (alpha: number, beta: number, radius: number, target: Vector3, scene: Scene) => {
    this.mainCamera = new ArcRotateCamera('mainCam', alpha, beta, radius, target, scene);
    this.mainCamera.attachControl(document.querySelector('#render-canvas'), true);
  }

  /**
  * Initialisiert die MainCamera
  */
  public static InitCamera() {
    if (typeof this.mainCamera !== "undefined") {
      this.mainCamera.angularSensibilityX = 2500;
      this.mainCamera.wheelPrecision = 100;
      this.mainCamera.panningSensibility = 0;

      this.mainCamera.lowerRadiusLimit = 1;
      this.mainCamera.upperRadiusLimit = 7;
      this.mainCamera.allowUpsideDown = false;
      this.mainCamera.upperBetaLimit = (Math.PI / 2) * 0.95;
      this.mainCamera.minZ = 0.1;
      this.mainCamera.maxZ = 50;

      this.mainCamera.useAutoRotationBehavior = true;
      this.mainCamera.useBouncingBehavior = true;
      this.mainCamera.bouncingBehavior!.lowerRadiusTransitionRange = .25;
      this.mainCamera.bouncingBehavior!.upperRadiusTransitionRange = -.25;
    }
  }

  /**
  * Erstellt eine Kamerafahrt
  */
  public static CreateCameraAnimation(trackShot: TrackingShot) {

    // timeline mit start und complete callbacks erstellen
    let trackingShotTimeline = gsap.timeline({
      onStart: () => {
        this.isTrackingShotRunning = true;
        this.mainCamera.detachControl();
      },
      onComplete: () => {
        this.mainCamera.attachControl(document.querySelector('#render-canvas'), true);
        this.isTrackingShotRunning = false;
      }
    });

    // "Überdrehen" der Kamera verhindern
    let targetAlpha = trackShot.alpha;
    let currentAlpha = this.mainCamera.alpha;

    if (trackShot.preventSpin) {
      currentAlpha = currentAlpha % (Math.PI * 2);
      this.mainCamera.alpha = currentAlpha;
      let alphaDelta = currentAlpha - targetAlpha;
      if (Math.abs(alphaDelta) > Math.PI) {
        if (alphaDelta < 0) { targetAlpha -= Math.PI * 2 }
        if (alphaDelta > 0) { targetAlpha += Math.PI * 2 }
      }
    }

    // Kamerafahrt erstellen
    trackingShotTimeline.to(this.mainCamera, {
      alpha: targetAlpha,
      beta: trackShot.beta,
      radius: trackShot.radius,
      duration: trackShot.duration,
      ease: trackShot.ease,
      onComplete: () => {
        while (this.mainCamera.alpha < 0) {
          this.mainCamera.alpha += Math.PI * 2;
        }
        this.mainCamera.alpha = this.mainCamera.alpha % (Math.PI * 2);
      }
    }).to(this.mainCamera.target, {
      x: trackShot.target.x,
      y: trackShot.target.y,
      z: trackShot.target.z,
      ease: trackShot.ease,
      duration: trackShot.duration
    }, "<")
  }
}